module.exports = __webpack_public_path__ + "img/faq-search-filter-sp.cb7776cd.jpg";